/** React Query hooks for Banker leads data. */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { expertApi } from '../services/expertApi';

export function useBankerLeads(params: {
  status?: string;
  source?: string;
  lead_type?: string;
  limit?: number;
  offset?: number;
} = {}) {
  return useQuery({
    queryKey: ['banker-leads', params],
    queryFn: () => expertApi.getBankerLeads(params),
    refetchInterval: 60000,
  });
}

export function useBankerLead(id: number) {
  return useQuery({
    queryKey: ['banker-lead', id],
    queryFn: () => expertApi.getBankerLead(id),
    enabled: !!id,
  });
}

export function useMarkLeadActedOn() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => expertApi.markLeadActedOn(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['banker-leads'] });
    },
  });
}

export function useBankerNotifications(params: {
  date_range?: string;
  priority?: string;
  limit?: number;
  offset?: number;
} = {}) {
  return useQuery({
    queryKey: ['banker-notifications', params],
    queryFn: () => expertApi.getBankerNotifications(params),
    refetchInterval: 60000,
  });
}
